/**
 * Partner logos we host ourselves, served from public/partner-logos/.
 *
 * Partner portal config points display_logo_url at third-party hotlinks
 * (Wikimedia, gstatic, licdn, googleusercontent). VISA's broke when Wikimedia
 * renamed the file, leaving the programme with no logo. A copy served from
 * getfleek.com can't be renamed out from under us.
 *
 * These are a fallback, not an override: the configured URL is still tried
 * first, so fixing a partner's config takes effect without a deploy.
 */

const HOSTED = [
  // visa, and the regional visa1…visa6 programmes, which carry no logo of
  // their own in config.
  { slug: /^visa\d*$/i, src: '/partner-logos/visa.svg', name: 'Visa' },
];

const currentSlug = () => {
  try {
    return localStorage.getItem('partnerSlug') || '';
  } catch {
    return '';
  }
};

/** Our hosted logo for the current partner programme, if we have one. */
export const hostedPartnerLogo = (slug = currentSlug()) =>
  HOSTED.find((entry) => entry.slug.test(slug)) || null;
